/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Cancel_Existing_Subscription_MessageInputs */

const en_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`To use your mobile purchase on other devices, please first cancel your existing desktop purchase.`);
	return /** @type {LocalizedString} */ (`To use your mobile subscription on other devices, please first cancel your existing desktop subscription.`)
	
};

const id_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Untuk menggunakan pembelian seluler Anda di device lain, harap batalkan terlebih dahulu pembelian desktop Anda yang sudah ada.`);
	return /** @type {LocalizedString} */ (`Untuk menggunakan langganan mobile Anda di perangkat lain, harap batalkan langganan desktop yang ada.`)
	
};

const ms_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Untuk menggunakan pembelian mudah alih anda pada peranti lain, sila batalkan pembelian desktop sedia ada anda terlebih dahulu.`);
	return /** @type {LocalizedString} */ (`Untuk menggunakan langganan mudah alih anda pada peranti lain, sila batalkan terlebih dahulu langganan desktop sedia ada anda.`)
	
};

const ca_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Per fer servir la teva compra mòbil en altres aparells, cancel·la primer la teva compra d'escriptori existent.`);
	return /** @type {LocalizedString} */ (`Per utilitzar la teva subscripció mòbil en altres dispositius, primer hauràs de cancel·lar la teva subscripció d'escriptori existent.`)
	
};

const cs_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Chcete-li používat svůj mobilní nákup na jiných zařízeních, nejprve prosím zrušte stávající nákup pro desktop.`);
	return /** @type {LocalizedString} */ (`Pro použití mobilního předplatného na jiných zařízeních zrušte prosím nejprve stávající předplatné na stolním počítači.`)
	
};

const da_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`For at bruge dit mobilkøb på andre enheder skal du først annullere dit eksisterende desktop-køb.`);
	return /** @type {LocalizedString} */ (`For at bruge dit mobilabonnement på andre enheder skal du først annullere dit eksisterende desktopabonnement.`)
	
};

const de_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Um die von Ihnen erworbene Mobilversion auf anderen Geräten zu verwenden, stornieren Sie bitte zuerst Ihren Kauf der Desktopversion.`);
	return /** @type {LocalizedString} */ (`Um Ihr Abonnement der Mobilversion auf anderen Geräten zu verwenden, kündigen Sie bitte zuerst Ihr bestehendes Abonnement für die Desktopversion.`)
	
};

const et_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mobiiliostu kasutamiseks teistes seadmetes tühista esmalt oma olemasolev töölauaost.`);
	return /** @type {LocalizedString} */ (`Et kasutada oma mobiilset tellimust teistes seadmetes, tühistage esmalt oma olemasolev lauaarvuti tellimus.`)
	
};

const es_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Para usar tu compra móvil en otros dispositivos, primero cancela tu compra existente en computadora de escritorio.`);
	return /** @type {LocalizedString} */ (`Para usar tu suscripción móvil en otros dispositivos, primero debes cancelar tu suscripción de escritorio existente.`)
	
};

const fr_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pour utiliser votre achat mobile sur d’autres appareils, veuillez d’abord annuler votre achat pour ordinateur existant.`);
	return /** @type {LocalizedString} */ (`Pour utiliser votre abonnement mobile sur d’autres appareils, veuillez d’abord annuler votre abonnement pour ordinateur.`)
	
};

const hr_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Da biste koristili svoju mobilnu kupnju na drugim uređajima, prvo otkažite svoju postojeću desktop kupnju.`);
	return /** @type {LocalizedString} */ (`Da biste koristili svoju mobilnu pretplatu na drugim uređajima, prvo otkažite svoju postojeću pretplatu na stolnom računalu.`)
	
};

const it_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Per utilizzare il tuo acquisto mobile su altri dispositivi, annulla prima il tuo acquisto desktop esistente.`);
	return /** @type {LocalizedString} */ (`Per usare il tuo abbonamento mobile su altri dispositivi, annulla prima il tuo abbonamento desktop.`)
	
};

const lv_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Lai izmantotu mobilo pirkumu citās ierīcēs, lūdzu, vispirms atceliet esošo galddatora pirkumu.`);
	return /** @type {LocalizedString} */ (`Lai izmantotu jūsu mobilo abonementu citās ierīcēs, vispirms atceliet esošo darbvirsmas abonementu.`)
	
};

const lt_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Norėdami naudoti mobilųjį pirkinį kituose įrenginiuose, pirmiausia atšaukite esamą desktop pirkinį.`);
	return /** @type {LocalizedString} */ (`Norėdami naudoti mobilią prenumeratą kituose įrenginiuose, pirmiausia turite atšaukti esamą darbalaukio prenumeratą.`)
	
};

const hu_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ahhoz, hogy mobilos vásárlásodat más eszközökön is használhasd, kérjük, először mondd le a meglévő desktop vásárlásodat.`);
	return /** @type {LocalizedString} */ (`Ahhoz, hogy a mobil előfizetését más eszközökön is használhassa, először le kell mondania az aktuális asztali előfizetését.`)
	
};

const nl_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Om je mobiele aankoop op andere devices te gebruiken, moet je eerst je bestaande desktop-aankoop annuleren.`);
	return /** @type {LocalizedString} */ (`Om je mobiele abonnement op andere apparaten te gebruiken, annuleer eerst je bestaande desktop abonnement.`)
	
};

const nb_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`For å bruke ditt mobile kjøp på andre enheter, vennligst avbryt først ditt eksisterende desktop-kjøp.`);
	return /** @type {LocalizedString} */ (`Du må si opp ditt eksisterende desktop-abonnement for å bruke mobilabonnementet ditt på andre enheter.`)
	
};

const pl_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Aby korzystać z zakupu mobilnego na innych urządzeniach, najpierw anuluj istniejący zakup na komputerze.`);
	return /** @type {LocalizedString} */ (`Aby korzystać z subskrypcji mobilnej na innych urządzeniach, najpierw anuluj istniejącą subskrypcję na komputerze.`)
	
};

const pt_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Para usar sua compra mobile em outros dispositivos, cancele primeiro sua compra para desktop existente.`);
	return /** @type {LocalizedString} */ (`Para usar sua assinatura móvel em outros dispositivos, cancele primeiro sua assinatura de desktop existente.`)
	
};

const ro_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pentru a folosi achiziția ta mobilă pe alte dispozitive, te rugăm să anulezi mai întâi achiziția existentă pe desktop.`);
	return /** @type {LocalizedString} */ (`Pentru a utiliza abonamentul dvs. mobil pe alte dispozitive, vă rugăm să anulați mai întâi abonamentul dvs. desktop existent.`)
	
};

const sk_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ak chcete používať mobilný nákup na iných zariadeniach, najprv zrušte existujúci desktopový nákup.`);
	return /** @type {LocalizedString} */ (`Ak chcete používať svoje mobilné predplatné na iných zariadeniach, najprv zrušte existujúce predplatné na počítači.`)
	
};

const sl_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Za uporabo svojega mobilnega nakupa na drugih napravah najprej prekličite svoj obstoječi namizni nakup.`);
	return /** @type {LocalizedString} */ (`Za uporabo svoje mobilne naročnine na drugih napravah morate najprej preklicati svojo obstoječo naročnino za namizje.`)
	
};

const fi_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Käyttääksesi mobiiliostostasi muilla laitteilla, peruuta ensin olemassa oleva työpöytäostoksesi.`);
	return /** @type {LocalizedString} */ (`Jos haluat käyttää mobiilitilaustasi muilla laitteilla, peruuta ensin nykyinen työpöytätilauksesi.`)
	
};

const sv_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`För att använda ditt mobila köp på andra enheter, avbryt först ditt befintliga desktop-köp.`);
	return /** @type {LocalizedString} */ (`För att använda ditt mobila abonnemang på andra enheter, vänligen avsluta ditt befintliga desktopabonnemang först.`)
	
};

const vi_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Để sử dụng mua hàng trên thiết bị di động của bạn trên các thiết bị khác, vui lòng hủy mua hàng trên máy tính để bàn hiện có trước.`);
	return /** @type {LocalizedString} */ (`Để sử dụng gói đăng ký trên di động của bạn trên các thiết bị khác, vui lòng hủy đăng ký trên desktop hiện tại của bạn trước.`)
	
};

const tr_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mobil satın almanızı diğer cihazlarda kullanmak için lütfen önce mevcut masaüstü satın almanızı iptal edin.`);
	return /** @type {LocalizedString} */ (`Mobil aboneliğinizi diğer cihazlarda kullanmak için lütfen önce mevcut masaüstü aboneliğinizi iptal edin.`)
	
};

const el_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Για να χρησιμοποιήσετε την αγορά σας από κινητό σε άλλες συσκευές, παρακαλούμε ακυρώστε πρώτα την υπάρχουσα αγορά σας σε desktop.`);
	return /** @type {LocalizedString} */ (`Για να χρησιμοποιήσετε τη συνδρομή κινητού σας σε άλλες συσκευές, παρακαλούμε ακυρώστε πρώτα τη συνδρομή του επιτραπέζιου υπολογιστή σας.`)
	
};

const bg_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`За да използвате мобилната си покупка на други устройства, моля, първо отменете съществуващата си desktop покупка.`);
	return /** @type {LocalizedString} */ (`За да използвате мобилния си абонамент на други устройства, първо трябва да анулирате съществуващия си десктоп абонамент.`)
	
};

const ru_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Чтобы использовать вашу мобильную покупку на других устройствах, пожалуйста, сначала отмените имеющуюся десктопную покупку.`);
	return /** @type {LocalizedString} */ (`Чтобы использовать вашу мобильную подписку на других устройствах, пожалуйста, сначала отмените вашу текущую подписку на настольном компьютере.`)
	
};

const sr_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Да бисте користили своју мобилну куповину на другим уређајима, прво откажите постојећу desktop куповину.`);
	return /** @type {LocalizedString} */ (`Да бисте користили мобилну претплату на другим уређајима, најпре откажите важећу претплату на десктоп уређају.`)
	
};

const uk_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Щоб використовувати свою мобільну покупку на інших пристроях, спершу скасуйте свою наявну desktop-покупку.`);
	return /** @type {LocalizedString} */ (`Щоб використовувати вашу мобільну підписку на інших пристроях, спершу скасуйте існуючу десктопну підписку.`)
	
};

const ka_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`მობილური შეძენის სხვა მოწყობილობებზე გამოსაყენებლად, გთხოვთ, ჯერ გააუქმოთ თქვენი არსებული დესკტოპის შეძენა.`);
	return /** @type {LocalizedString} */ (`მობილური გამოწერის სხვა მოწყობილობებზე გამოყენებამდე, გთხოვთ ჯერ გააუქმოთ არსებული დესკტოპი გამოწერა.`)
	
};

const hi_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`अन्य डिवाइसों पर अपनी मोबाइल खरीद का उपयोग करने के लिए, कृपया पहले अपनी मौजूदा डेस्कटॉप खरीद रद्द करें।`);
	return /** @type {LocalizedString} */ (`अपने मोबाइल सब्सक्रिप्शन को अन्य डिवाइसों पर उपयोग करने के लिए, कृपया पहले अपनी मौजूदा डेस्कटॉप सदस्यता रद्द करें।`)
	
};

const th_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`หากต้องการใช้การซื้อบนมือถือของคุณกับอุปกรณ์อื่น โปรดยกเลิกการซื้อบนเดสก์ท็อปที่มีอยู่ของคุณก่อน`);
	return /** @type {LocalizedString} */ (`หากต้องการใช้การสมัครมือถือของคุณบนอุปกรณ์อื่น ๆ โปรดยกเลิกการสมัครเดสก์ท็อปที่มีอยู่ก่อน`)
	
};

const ko_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`다른 디바이스에서 모바일 구매를 사용하려면 먼저 기존 데스크톱 구매를 취소해 주세요.`);
	return /** @type {LocalizedString} */ (`다른 기기에서 모바일 구독을 사용하려면 기존 데스크톱 구독을 먼저 취소하세요.`)
	
};

const zh_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如要在其他设备上使用您的移动订阅，请先取消现有的桌面订阅。`)
};

const zh_tw_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`若要在其他裝置上使用您的行動購買，請先取消您現有的桌面購買。`);
	return /** @type {LocalizedString} */ (`若要於其他裝置使用您的行動訂閱服務，請先取消現有的桌面端訂閱服務。`)
	
};

const ja_cancel_existing_subscription_message = /** @type {(inputs: Cancel_Existing_Subscription_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`他のデバイスでモバイル購入を使用するには、まず既存のデスクトップ購入をキャンセルしてください。`);
	return /** @type {LocalizedString} */ (`モバイルサブスクリプションを他のデバイスで使用するには、まず既存のデスクトップサブスクリプションをキャンセルしてください。`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "To use your mobile purchase on other devices, please first cancel your existing desktop purchase." |
* | * | "To use your mobile subscription on other devices, please first cancel your existing desktop subscription." |
*
* @param {Cancel_Existing_Subscription_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cancel_existing_subscription_message = /** @type {((inputs: Cancel_Existing_Subscription_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Existing_Subscription_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cancel_existing_subscription_message(inputs)
	if (locale === "ms") return ms_cancel_existing_subscription_message(inputs)
	if (locale === "ca") return ca_cancel_existing_subscription_message(inputs)
	if (locale === "cs") return cs_cancel_existing_subscription_message(inputs)
	if (locale === "da") return da_cancel_existing_subscription_message(inputs)
	if (locale === "de") return de_cancel_existing_subscription_message(inputs)
	if (locale === "et") return et_cancel_existing_subscription_message(inputs)
	if (locale === "es") return es_cancel_existing_subscription_message(inputs)
	if (locale === "fr") return fr_cancel_existing_subscription_message(inputs)
	if (locale === "hr") return hr_cancel_existing_subscription_message(inputs)
	if (locale === "it") return it_cancel_existing_subscription_message(inputs)
	if (locale === "lv") return lv_cancel_existing_subscription_message(inputs)
	if (locale === "lt") return lt_cancel_existing_subscription_message(inputs)
	if (locale === "hu") return hu_cancel_existing_subscription_message(inputs)
	if (locale === "nl") return nl_cancel_existing_subscription_message(inputs)
	if (locale === "nb") return nb_cancel_existing_subscription_message(inputs)
	if (locale === "pl") return pl_cancel_existing_subscription_message(inputs)
	if (locale === "pt") return pt_cancel_existing_subscription_message(inputs)
	if (locale === "ro") return ro_cancel_existing_subscription_message(inputs)
	if (locale === "sk") return sk_cancel_existing_subscription_message(inputs)
	if (locale === "sl") return sl_cancel_existing_subscription_message(inputs)
	if (locale === "fi") return fi_cancel_existing_subscription_message(inputs)
	if (locale === "sv") return sv_cancel_existing_subscription_message(inputs)
	if (locale === "vi") return vi_cancel_existing_subscription_message(inputs)
	if (locale === "tr") return tr_cancel_existing_subscription_message(inputs)
	if (locale === "el") return el_cancel_existing_subscription_message(inputs)
	if (locale === "bg") return bg_cancel_existing_subscription_message(inputs)
	if (locale === "ru") return ru_cancel_existing_subscription_message(inputs)
	if (locale === "sr") return sr_cancel_existing_subscription_message(inputs)
	if (locale === "uk") return uk_cancel_existing_subscription_message(inputs)
	if (locale === "ka") return ka_cancel_existing_subscription_message(inputs)
	if (locale === "hi") return hi_cancel_existing_subscription_message(inputs)
	if (locale === "th") return th_cancel_existing_subscription_message(inputs)
	if (locale === "ko") return ko_cancel_existing_subscription_message(inputs)
	if (locale === "zh") return zh_cancel_existing_subscription_message(inputs)
	if (locale === "zh-tw") return zh_tw_cancel_existing_subscription_message(inputs)
	if (locale === "ja") return ja_cancel_existing_subscription_message(inputs)
	return en_cancel_existing_subscription_message(inputs)
});